import { isChatUnavailablePayload } from "../../utils/chatAvailability";
import { clearAssistantUnavailable, setAssistantUnavailable } from "../../reducers/assistantReducer";

// Opening and restart streams share the same terminal fault contract as the
// other chat surfaces. Returning early prevents a typed fault from being
// mistaken for a successful, empty opening.
export const applyTaskChatFrame = ({
  data,
  dispatch,
  setChatMessages,
  createTaskThread,
  projectId,
  taskId,
}) => {
  if (isChatUnavailablePayload(data)) {
    dispatch(setAssistantUnavailable({ reason: data.error.code }));
    return false;
  }

  if (data.messages) {
    setChatMessages((previous) => [...previous, ...data.messages]);
  }

  if (data.chatId) {
    dispatch(createTaskThread({
      chatId: data.chatId,
      projectId: projectId || null,
      taskId,
    }));
  }
  return Boolean(data.messages || data.chatId);
};

export const finalizeTaskChatOpening = async ({
  openingSucceeded,
  openingFailed = false,
  dispatch,
  persistTaskFile,
}) => {
  if (!openingSucceeded || openingFailed) return false;
  dispatch(clearAssistantUnavailable());
  await persistTaskFile();
  return true;
};
